import { render, staticRenderFns } from "./FieldSelect.vue?vue&type=template&id=1195579c&scoped=true&"
import script from "./FieldSelect.vue?vue&type=script&lang=js&"
export * from "./FieldSelect.vue?vue&type=script&lang=js&"
import style0 from "./FieldSelect.vue?vue&type=style&index=0&id=1195579c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1195579c",
  null
  
)

export default component.exports